'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import TextInput from 'components/base/form-components/TextInput';

import constants from 'constants/appConstants';
import utils from 'services/utils';


const propTypes = {
    roundToMinutes: PropTypes.number,
    display24HrFormat: PropTypes.bool,
};

const defaultProps = {
    roundToMinutes: null,
    display24HrFormat: false,
};

class TimeInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            currentValue: this.props.value,
        };
    }    

    onBlurCallback = (event) => {
        const currentValue = utils.formatShortTime(event.currentTarget.value, this.props.roundToMinutes, this.props.display24HrFormat);
        if (currentValue !== null) {
            // Big hack here to force a render if the currentValue doesn't change. Not sure why but the 
            // page doesn't update if currentValue stays the same.
            if (currentValue === this.state.currentValue) {
                this.setState({
                    currentValue: '00:00 AM',
                }, function () {
                    this.setState({
                        currentValue,
                    }, function () {
                        if (this.props.onBlurCallback) {
                            this.props.onBlurCallback(this, currentValue);
                        }
                    }.bind(this));
                }.bind(this));
            } else {
                this.setState({
                    currentValue,
                }, function () {
                    if (this.props.onBlurCallback) {
                        this.props.onBlurCallback(this, currentValue);
                    }
                }.bind(this));
            }
        }
    };

    onFocusCallback = (event) => {
        event.currentTarget.select();
    };

    render() {

        const validations = {
            timeValidation: this.state.currentValue,
        };

        const validationErrors = {
            timeValidation: constants.error.FORMS.SMART_TIME_VALIDATION,
        };

        if (this.props.extraValidations) {
            for (const extraValidation of this.props.extraValidations) {
                const validationKey = Object.keys(extraValidation[0]);
                validations[validationKey] = extraValidation[0][validationKey][0];
                validationErrors[validationKey] = extraValidation[0][validationKey][1];
            }
        }
        
        return (
            <TextInput
                {...this.props}
                ref={(n) => this.node = n}
                onBlurCallback={this.onBlurCallback}
                onFocusCallback={this.onFocusCallback}
                value={this.state.currentValue}
                validations={validations}
                validationErrors={validationErrors}
            />
        );
    }
}

TimeInput.propTypes = propTypes;
TimeInput.defaultProps = defaultProps;

export default TimeInput;